import { FC } from 'react';
import { ContainerRow } from '../shared/container-row/container-row';
import { Button } from '../shared/button/button';
import { FormData } from '../../types';
import { maxPages, minPages, PRINTED_PAGE } from '../../constants';
import './container.css';

type Props = {
  setFormData: (formData: FormData) => void;
  formData: FormData;
}

export const Container: FC<Props> = ({
  setFormData,
  formData,
}) => {
  const printedPagesData = formData.printedPagesData;
  const printedPagesCount = printedPagesData.length;

  const deleteRow = (index: number) => {
    const nextPrintedPagesData = printedPagesData.filter((page, i) => i !== index);

    setFormData({ ...formData, printedPagesData: nextPrintedPagesData });
  };

  const addRaw = () => {
    const nextPrintedPagesData = [...printedPagesData, PRINTED_PAGE];

    setFormData({ ...formData, printedPagesData: nextPrintedPagesData });
  };

  const setColorCount = (index: number, count: number) => {
    const nextPrintedPagesData = printedPagesData.map((page, i) => ({
      ...page,
      colorCount: (i === index) ? count : page.colorCount,
    }));
    
    setFormData({ ...formData, printedPagesData: nextPrintedPagesData });
  };

  const onBackside = (index: number) => {
    const nextPrintedPagesData = printedPagesData.map((page, i) => ({
      ...page,
      backSide: (i === index) ? (page.backSide ? 0 : 1) : page.backSide,
    }));

    setFormData({ ...formData, printedPagesData: nextPrintedPagesData });
  };

  return (
    <div className="container">
      <div className="container-header">
        <span></span>
        <span>Количество цветов</span>
        <span>Обратная сторона</span>
      </div>
      <div className="container-items">
        {
          printedPagesData.map((page, index) => (
            <ContainerRow
              key={index}
              index={index}
              name={`Лист ${index + 1}`}
              onDelete={deleteRow}
              isDeletable={index === minPages}
              setColorCount={setColorCount}
              onBackside={onBackside}
              printedPage={page}
            />
          ))
        }
      </div>
      <Button
        text="Добавить лист"
        onClick={addRaw}
        disabled={printedPagesCount === maxPages}
      />
    </div>
  );
};